import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmSelectAllComponent } from './sm-select-all.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SmErrorModule } from '../sm-error/sm-error.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [SmSelectAllComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,SmErrorModule,
    NgSelectModule,
    NgbModule
  ],
  exports:[SmSelectAllComponent]
})
export class SmSelectAllModule { }
